import React from 'react';
import PropTypes from 'prop-types';
import DocumentControlItem from './DocumentControlItem';
import { DataGrid } from '../index';

const DocumentControl = (props) => {
  /*
   Organiza a lista de documentos */
  const handleItens = () => {
    const mappedDocuments = props.documents;
    const documents = [];
    const { protocolo, acao, requerimento } = { ...props };
    if (mappedDocuments) {
      const requerimentoProps = requerimento;
      mappedDocuments.forEach((element) => {
        if (element.documentType !== 3) {
          documents.push(<DocumentControlItem
            tiposDocumentos={props.tiposDocumentos}
            document={element}
            protocolo={protocolo}
            auth={props.auth}
            acao={acao}
            requerimento={requerimentoProps}
            atualizarDocumentosProbatorios={props.atualizarDocumentosProbatorios}
            tipoRequerimento={props.tipoRequerimento}
          />);
        } else {
          // eslint-disable-next-line
          if (props.auth.checkPermission(['fornecer-parecer-medico-rpps'])) {
            documents.push(<DocumentControlItem
              tiposDocumentos={props.tiposDocumentos}
              document={element}
              protocolo={protocolo}
              auth={props.auth}
              acao={acao}
              requerimento={requerimentoProps}
              atualizarDocumentosProbatorios={props.atualizarDocumentosProbatorios}
              tipoRequerimento={props.tipoRequerimento}
            />);
          }
        }
      });
    }
    return documents;
  };

  return props.documents.length > 0 ? (
    <DataGrid title="Documentos Probatórios" icon="ico-docs" >
      {handleItens()}
    </DataGrid>
  ) : null;
};

DocumentControl.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    codigo: PropTypes.string,
    tipoDocumento: PropTypes.number,
  })).isRequired,
  tiposDocumentos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })).isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  atualizarDocumentosProbatorios: PropTypes.func.isRequired,
  tipoRequerimento: PropTypes.number.isRequired,
};

export default DocumentControl;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/DocumentControl.jsx